import { SVGProps } from 'react';

export const HighPriority = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="15"
    height="12"
    viewBox="0 0 15 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.5859 2H0.585938V0H14.5859V2Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.5859 7H0.585938V5H14.5859V7Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.5859 12H0.585938V10H14.5859V12Z"
      fill="currentColor"
    />
  </svg>
);
